import { render, staticRenderFns } from "./ModalProfileRegister.vue?vue&type=template&id=4cd43e51&"
import script from "./ModalProfileRegister.vue?vue&type=script&lang=js&"
export * from "./ModalProfileRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports